"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SENTRY_TAG_RACE_CONDITION = void 0;
exports.SENTRY_TAG_RACE_CONDITION = "raceCondition";
//# sourceMappingURL=sentry.js.map